import { format } from "date-fns";
import * as XLSX from "xlsx";

export const PACKAGE_STATUS_ARRAY: string[] = [
  "3P_DROPSHIP",
  "ARRIVED_AT_FACILITY",
  "CANCELED",
  "CLIENT_RETURN_NO_ATTEMPT",
  "DAMAGED",
  "DELIVERED",
  "DEPARTED_FROM_ORIGIN",
  "ExceptionCode:BDA",
  "ExceptionCode:CLO",
  "ExceptionCode:DAM",
  "ExceptionCode:DNA",
  "ExceptionCode:LAT",
  "ExceptionCode:REF",
  "ExceptionCode:SRP",
  "ExceptionCode:ZPP",
  "INFO_RECEIVED",
  "MAX_ATTEMPTS_REACHED",
  "MISSING",
  "NOT_ARRIVED_AT_FACILITY",
  "OUT_FOR_DELIVERY",
  "PICKED_UP",
  "PickupExceptionCode:BDA",
  "PickupExceptionCode:CLO",
  "PickupExceptionCode:DNA",
  "PickupExceptionCode:REF",
  "PickupExceptionCode:WX1",
  "PickupExceptionCode:ZPP",
  "PLANNED",
  "RETURNED_TO_STATION",
];

export const PARCEL_CENTER_ARRAY: string[] = [
  "PHLA",
  "HOUA",
  "ATLA",
  "DFWA",
  "PHXA",
  "PHLB",
  "PITA",
  "CVGA",
  "STLA",
  "MSPA",
  "SANA",
  "BOSA",
  "SNAA",
  "PHXB",
];

export const prepareAndDownloadFile = (fileData: any[], fileName: string) => {
  const worksheet = XLSX.utils.json_to_sheet(fileData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet);
  XLSX.writeFile(
    workbook,
    fileName + format(new Date(), "yyyyMMddHHmmss") + ".xlsx",
    {
      compression: true,
    }
  );
};
